var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBrightness(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#222",
    d: "M15,19 C11.1340068,19 8,15.8659932 8,12 C8,8.13400675 11.1340068,5 15,5 C18.8659932,5 22,8.13400675 22,12 C22,15.8659932 18.8659932,19 15,19 Z M15,18 C18.3137085,18 21,15.3137085 21,12 C21,8.6862915 18.3137085,6 15,6 C15,7.5 15,16.5 15,18 Z M3,11.5 L7,11.5 L7,12.5 L3,12.5 L3,11.5 Z M14,0 L15,0 L15,4 L14,4 L14,0 Z M14,20 L15,20 L15,24 L14,24 L14,20 Z M8.56066017,17.232233 L9.26776695,17.9393398 L6.43933983,20.767767 L5.73223305,20.0606602 L8.56066017,17.232233 Z M8.56066017,6.76776695 L5.73223305,3.93933983 L6.43933983,3.23223305 L9.26776695,6.06066017 L8.56066017,6.76776695 Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrightness);
export default __webpack_public_path__ + "static/media/Brightness.3bef442a.svg";
export { ForwardRef as ReactComponent };